import React, { useEffect, useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "services/user";
import Header from "components/common/Header";
import Sidebar from "components/common/Sidebar";
import AddCreditToTeam from "components/admin/AddCreditToTeam";
import UpdateInfraCost from "components/admin/UpdateInfraCost";
import Users from "pages/Users";

const AdminPanel: React.FC = () => {
  const navigate = useNavigate();
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  // Tab state using numbers instead of strings
  const [activeTab, setActiveTab] = useState<number>(0);
  const [toast, setToast] = useState({
    show: false,
    heading: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    // Check if the user is a super admin by calling the API directly
    const checkSuperAdminStatus = async () => {
      try {
        const response = await getUserProfile();
        if (response?.data?.is_super_admin) {
          setIsSuperAdmin(true);
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error checking super admin status:", error);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    checkSuperAdminStatus();
  }, [navigate]);

  return (
    <div className="dashboard-wrapper flex">
      {/* Sidebar */}
      <Sidebar />

      {/* dashboard main */}
      <div className="w-[calc(100%_-_72px)] ml-auto">
        {/* Header */}
        <Header type={"settings"} />

        {/* Main */}
        <div className="pt-6 px-8 h-[calc(100vh_-_70px)] overflow-y-scroll scrollbar-adjust">
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : !isSuperAdmin ? (
            <div className="bg-white rounded-lg shadow-md p-6 border border-[#EAECF0]">
              <h1 className="text-2xl font-interSemiBold text-[#101828] mb-4">
                Access Denied
              </h1>
              <p className="text-[#475467]">
                You do not have permission to access this page. This page is
                only accessible to super administrators.
              </p>
            </div>
          ) : (
            <>
              <h2 className="text-[#101828] text-3xl font-semibold pb-5">
                Super Admin Panel
              </h2>

              {/* Switcher */}
              <ul className="flex items-center mb-5 gap-x-4">
                <li
                  onClick={() => setActiveTab(0)}
                  className={`block text-sm font-interSemiBold hover:text-[#1E0AF5] hover:bg-[#E8E6FE] rounded-md py-2 px-4 cursor-pointer ${
                    activeTab === 0
                      ? "text-[#1E0AF5] bg-[#E8E6FE]"
                      : "text-[#667085]"
                  }`}
                >
                  Add Credit to Team
                </li>
                <li
                  onClick={() => setActiveTab(1)}
                  className={`block text-sm font-interSemiBold hover:text-[#1E0AF5] hover:bg-[#E8E6FE] rounded-md py-2 px-4 cursor-pointer ${
                    activeTab === 1
                      ? "text-[#1E0AF5] bg-[#E8E6FE]"
                      : "text-[#667085]"
                  }`}
                >
                  Update Infra Cost
                </li>
                <li
                  onClick={() => setActiveTab(2)}
                  className={`block text-sm font-interSemiBold hover:text-[#1E0AF5] hover:bg-[#E8E6FE] rounded-md py-2 px-4 cursor-pointer ${
                    activeTab === 2
                      ? "text-[#1E0AF5] bg-[#E8E6FE]"
                      : "text-[#667085]"
                  }`}
                >
                  Users
                </li>
              </ul>

              {/* Add Credit to Team Tab */}
              {activeTab === 0 && (
                <div className="bg-white">
                  <AddCreditToTeam />
                </div>
              )}

              {/* Update Infra Cost Tab */}
              {activeTab === 1 && (
                <div className="bg-white">
                  <UpdateInfraCost />
                </div>
              )}
              {activeTab === 2 && (
                <div className="bg-white">
                  <Users />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
